
<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      保证金管理
      <small>/保证金管理列表</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">保证金管理列表</h4>
              </div>
              <!-- end panel-heading -->
              <el-card class="box-card">
              <form  style="margin-top:16px;" >
                <fieldset>
                  <div class="form-group row m-b-15">
                    <label class="col-md-1 col-form-label">合同编号</label>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="合同编号"
                        v-model="form.contractNo"
                      >
                    </div>

                  <label class="col-md-1 col-form-label">合同标题</label>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="合同标题"
                        v-model="form.contractTitle"
                      >
                    </div>
                    <label class="col-md-1 col-form-label">时间</label>
                      <div class="col-md-3">
                        <el-date-picker
                          style="width:100%;height:34px;"
                          v-model="form.TimeValue"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="ChangePicker"
                        ></el-date-picker>
                      </div>
                    <div class="col-md-2"></div>
                    <label class="col-md-1 col-form-label LineSpacing">服务商名称</label>
                    <div class="col-md-2 LineSpacing">
                       <el-select
                          v-model="form.recomName"
                          style="width:100%;font-size:12px;"
                          clearable
                          filterable
                          placeholder="服务商名称"
                        >
                          <el-option
                            v-for="item in recomNameList"
                            :key="item.recomId"
                            :label="item.recomName"
                            :value="item.recomId"
                          ></el-option>
                        </el-select>
                    </div>
                    <div class="col-md-1 LineSpacing">
                      <a
                        class="btn btn-primary ButtonColor m-r-5"
                        @click="SearchClick()"
                        style="float:right;"
                      >查询</a>
                    </div>
                    <div class="col-md-11"></div>
                     <div class="col-md-1">
                    <a class="btn btn-primary btn-sm ButtonColor a_class"
                      @click="AddClick()"
                    >新增保证金</a>
                  </div>
                  </div>
                </fieldset>
              </form>
                <el-table
                      :data="tableData3"
                      style="width: 100%"
                      size="medium"
                      border
                      :header-cell-style="{background:'#ffffff'}"
                    >
                      <el-table-column
                        width="50"
                        prop="goodsid"
                        label="序号"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="contractNo"
                        label="合同编号"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="contractTitle"
                        label="合同标题"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="depositScope"
                        label="合同区域"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="goodsId"
                        label="合同品类"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>

                      <el-table-column
                        width="100"
                        prop="pznCode"
                        label="合同期限"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="recomName"
                        label="服务商"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="160"
                        prop="clientSignTime"
                        label="客户签约时间"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="80"
                        prop="deposit"
                        label="保障金"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="180"
                        prop="depositTime"
                        label="保障金缴纳时间"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="180"
                        prop="depositStatus"
                        label="订单状态"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="160"
                        prop="fileUrl"
                        label="缴纳凭证"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <div class="demo-image__preview">
                            <el-image
                              style="width: 50px; height: 50px"
                              :src="scope.row.fileUrl"
                              @click="openImg(scope.row.fileUrl)"
                            ></el-image>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="180"
                        fit
                        label="操作"
                        align="center"
                        resizable
                        fixed="right"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <el-button
                            class="btn btn-primary btn-sm ButtonColor"
                            size="small"
                            @click="edit(scope.row)"
                          >编辑</el-button>
                          <el-button
                            class="btn btn-warning btn-sm ButtonColor"
                            size="small"
                            @click="del(scope.row)"
                          >删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  <div class="bottom">
                    <div class="block">
                      <!---- totalCount  ------- pageSize   ----->
                      <el-pagination
                        :current-page="pageNo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        background
                      ></el-pagination>
                    </div>
                  </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>

      <!--  -->
      <el-dialog title :visible.sync="outerVisible" :before-close="handleClose" width="35%">
        <!-- 编辑    新增 -->
        <div v-if="EditDialog === 1" class="ModelPadding">
          <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
            class="demo-ruleForm"
            style="width:90%"
          >
            <el-form-item label="合同编号:" prop="contractNo">
              <el-input v-model="ruleForm.contractNo" class="DistributorMargin"></el-input>
            </el-form-item>
            <el-form-item label="服务商：" prop="recomName1">
              <el-select
                v-model="ruleForm.recomName"
                style="width:96%;margin-left:4%;"
                clearable
                filterable
                placeholder="请输入服务商名称"
              >
                <el-option
                  v-for="item in recomNameList"
                  :key="item.recomId"
                  :label="item.recomName"
                  :value="item.recomId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="缴纳保证金金额:" prop="deposit">
              <el-input v-model="ruleForm.deposit" class="DistributorMargin"></el-input>
            </el-form-item>
            <el-form-item label="缴纳时间: " prop="depositTime">
              <div class="block left">
                <el-date-picker
                  v-model="ruleForm.depositTime"
                  type="datetime"
                  @change="FormatAllDateadd"
                  placeholder="开始日期时间"
                  style="width:100%;"
                ></el-date-picker>
              </div>
            </el-form-item>

            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="上传合同: " prop="fileUrl">
                    <!--  upload_right   :http-request ="httprequest" -->
                    <el-upload
                      class="upload-demo upload_right1"
                      list-type="picture-card"
                      action="string"
                      ref="upload"
                      accept=".PDF, .doc, .docx"
                      :limit="2"
                      :on-remove="handleRemove"
                      :http-request="httpRequest"
                      :file-list="fileList"
                    >
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>

                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button
                class="btn btn-primary btn-sm ButtonColor"
                @click="MakeSureEdit('ruleForm')"
                :disabled="disabled"
              >提交</button>
            </div>
            <div class="swal-button-container">
              <div class="btn btn-primary btn-sm ButtonColor" @click="outerVisible = false">取消</div>
            </div>
          </div>
        </div>
     
      </el-dialog>
  
      <!-- 删除 -->
      <el-dialog title :visible.sync="outerVisible1" :before-close="handleClose" width="25%">
        <div v-if="EditDialog === 2" class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">您确定吗?</div>
          <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--confirm btn btn-primary"
                @click="MakeSure"
                :disabled="disabled"
              >确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible1 = false"
              >取消</div>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 缴纳凭证 -->
      <el-dialog title width="500px" :visible.sync="imgVisible" class="img-dialog">
        <h3>缴纳凭证</h3>
        <el-card :body-style="{ padding:'0', background: '#fff' }">
          <img :src="dialogImgUrl" width="80%" height="80%" />
        </el-card>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "deposit",
  data() {
    var checkcontractNo = (rule, value, callback) => {
      setTimeout(() => {
        // var reg = /^[0-9A-Za-z]{1,16}$/;reg.test(value)
        if (!value) {
          callback(new Error("请输入正确的合同编号"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkdeposit = (rule, value, callback) => {
      setTimeout(() => {
        // var reg = /^[0-9A-Za-z]{1,16}$/;reg.test(value)
        if (!value) {
          callback(new Error("请输入保证金额"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      fileList: [],
      imgVisible: false,
      dialogImgUrl: "",
      // 显示 隐藏   按钮  数据
      hiddenbutton: "",
      // 对话框
      outerVisible: false,
      outerVisible1: false,
      outerVisible2: false,
      outerVisible3: false,
      DialogTitle: "编辑",
      disabled: false,
      EditDialog: 1,
      director:0,
      ruleForm: {},
      CurrentSelection: [],
      // 当前页  ---- 默认显示第几页
      pageNo: 1,
      // 当前显示 数据的数据量
      pageSize: 10,
      // 数据总数量  ---- 总条数
      totalCount: 0,
      // 上传合同，
      fileformData: {},
      dialogImageUrl: "",
      dialogVisible: false,
      // 缴纳凭证
      src: "",
      // 开始时间  （yyyy-MM-dd HH:mm:ss）
      startTime: "",
      // 结束时间  （yyyy-MM-dd HH:mm:ss）
      endTime: "",
      form: {
        //合同编号
        contractNo: "",
        // 合同标题
        contractTitle: "",

        recomName: ""
      },
      // 列表服务商名称
      recomNameList: [],
      // recomId:"",
      // 编辑服务商名称
      addrecomNameList: [],
      // 新增 编辑  数据
      ruleForm: {
        contractNo: "",
        // 编辑的服务商
        recomName1: "",
        //  缴纳时间
        depositTime: "",
        // 保障金额
        deposit: "",
        fileUrl: ""
      },
      rules: {
        contractNo: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
          { validator: checkcontractNo, trigger: "blur" }
        ],
        depositTime: [
          { required: true, message: "请输入时间", trigger: "blur" }
        ],
        fileUrl: [{ required: true, message: "上传合同", trigger: "blur" }],
        deposit: [
          { required: true, message: "请输入保证金金额", trigger: "blur" },
          { validator: checkdeposit, trigger: "blur" }
        ]
      },
      Formdata: {
        TimeValue: ""
      },
      //   表格的 数据
      tableData3: []
    };
  },
  created() {
    this.initData();
    this.initDatabutton();
    this.initDatarecomNameList();
  },
  mounted() {
   // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
  },
  methods: {
    // 初始化数据
    initData() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobDepositController/queryDepositByPage",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          // that.form.contractNo
          // 合同编号
          contractNo: that.form.contractNo,
          // 合同标题
          contractTitle: that.form.contractTitle,
          // 服务商id
          // recomId:1,
          recomId: that.form.recomName,
          // current:,
          //  运营标识：1-运营总监 2-普通运营
          director: that.director,
          depositStatus:0,
          depositStatus:2
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          for (var i = 0; i < response.data.data.records.length; i++) {
            //  goodsid  为  自定义  属性 --- 【序号】
            response.data.data.records[i].goodsid =
              Number((that.pageNo - 1) * that.pageSize) + Number(i) + 1;
          }
          if (response.data.data.records.length > 0) {
            // 审核状态 1-未审核，0-驳回，2-审核通过
            for (var value of response.data.data.records) {
              value.depositScope = value.province + " " + value.city;

              if (value.depositStatus == 1) {
                value.depositStatus = "未审核";
              } else if (value.depositStatus == 0) {
                value.depositStatus = "驳回";
              } else if (value.depositStatus == 2) {
                value.depositStatus = "审核通过";
              }
            }
            this.tableData3 = response.data.data.records;
            this.totalCount = response.data.data.total;
          }
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    //显示 隐藏   按钮  数据
    initDatabutton() {
      let that = this;
      const options = {
        //  获取当前登录人角色
        url: "/distribution/B2cOrderInfoController/parsingUserTob",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({})
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          //   9533-超管、8533-企业管理员、7533-运营、6533-服务商
          // let arrname = ["9533", "8533", "7533", "6533"];
          this.hiddenbutton = String(response.data.data.roleId);
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    // 服务商 名称
    initDatarecomNameList() {
      let that = this;
      const options = {
        url: "/distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          //  运营标识：1-运营总监 2-普通运营
          director: that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          this.recomNameList = response.data.data;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    //  删除合同
    handleRemove(file, fileList) {},

    openImg(url) {
      if (url) {
        this.imgVisible = true;
        this.dialogImgUrl = url;
      }
    },

    //  覆盖默认上传行为
    httpRequest(param) {
      this.dialogImageUrl = URL.createObjectURL(param.file);
      let fd = new FormData();
      fd.append("file", param.file);
      let that = this;
      const options = {
        url: "distribution/FileController/uploadFileToFast",
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        data: fd
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.ruleForm.fileUrl = response.data.data;
            that.$notify({
              title: " ",
              message: "文件上传成功",
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },

    //   列表中的  上传凭证
    uploadPicture(param) {
      // var fileType = param.file.type;
      // console.log(param);
      this.dialogImageUrl = URL.createObjectURL(param.file);
      // console.log(this.dialogImageUrl);
      const formData = new FormData();
      formData.append("file", param.file);
      this.fileformData = formData;
      let that = this;
      const options = {
        url: "distribution/FileController/uploadFileToFast",
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        data: that.fileformData
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.ruleForm.fileUrl = response.data.data;
            that.$notify({
              title: "",
              message: response.data.message,
              type: "success"
            });
            // that.outerVisible = false;
            //  that.percentageShow =  true;
            setTimeout(() => {
              that.percentage = 100;
              that.percentagestatus = "success";
            }, 100);
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    // 查询数据
    SearchClick() {
      this.pageNo=1;
      this.initData();
    },
    // 新增
    AddClick() {
      this.initDatarecomNameList();
      this.ruleForm = {};
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
        console.log(this.$refs["ruleForm"].resetFields());
      }
      this.outerVisible = true;
      this.DialogTitle = "新增";
      this.EditDialog = 1;

      if (this.fileList) {
        this.fileList.splice(0, this.fileList.length);
      }
    },
    // 详情的处理函数
    handleClick1(row, index) {
      // console.log(row);
      this.$router.push({
        name: "depositdetail",
        path: "/depositdetail",
        query: {
          contractId: row.contractId,
          fileUrl: row.fileUrl,
          data: JSON.stringify(row)
        }
      });
    },
    // 审核函数
    edit1(item) {
      this.outerVisible3 = true;
      this.DialogTitle = "审核";
      this.EditDialog = 4;
      this.ruleForm = MethodsBus.cloneRow(item);
    },
    // 上传凭证的处理函数
    handleClick(row, index) {
      this.outerVisible2 = true;
      this.EditDialog = 3;
      this.DialogTitle = "上传凭证";
      this.ruleForm = MethodsBus.cloneRow(row);
      console.log(this.ruleForm.fileUrl);
    },
    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "编辑") {
        // console.log(that.ruleForm.fileUrl);
        that.$refs[formName].validate(valid => {
          if (valid) {
            const options = {
              url: "/distribution/B2cTobDepositController/editDeposit",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                // 合同编号
                contractNo: that.ruleForm.contractNo,
                // 保障金
                deposit: that.ruleForm.deposit,
                // 缴纳时间
                depositTime: that.ruleForm.depositTime,

                depositId: that.ruleForm.depositId,

                depositCertificateFileId:
                  that.ruleForm.depositCertificateFileId,

                fileUrl: that.ruleForm.fileUrl
              })
            };
            axios(options)
              .then(function(response) {
                if (response.data.code == 200) {
                  that.outerVisible = false;
                  // that.disabled = false;
                  that.initData();
                  that.$notify({
                    title: "成功",
                    message: "编辑成功",
                    type: "success"
                  });
                } else {
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            // that.disabled = true;
            const options = {
              url: "/distribution/B2cTobDepositController/addDeposit",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                // 合同编号
                contractNo: that.ruleForm.contractNo,
                // 保障金
                deposit: that.ruleForm.deposit,
                // 缴纳时间
                depositTime: that.ruleForm.depositTime,

                fileUrl: that.ruleForm.fileUrl
              })
            };
            axios(options)
              .then(function(response) {
                if (response.data.code == 200) {
                  that.outerVisible = false;
                  // that.disabled = false;
                  that.initData();
                  that.$notify({
                    title: "成功",
                    message: "新增成功",
                    type: "success"
                  });
                } else {
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                // that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "上传凭证") {
        let that = this;
        const options = {
          url: "/distribution/B2cTobDepositController/editDeposit",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            // 合同编号
            contractNo: that.ruleForm.contractNo,
            // 保障金
            deposit: that.ruleForm.deposit,
            // 缴纳时间
            depositTime: that.ruleForm.depositTime,

            depositId: that.ruleForm.depositId,

            depositCertificateFileId: that.ruleForm.depositCertificateFileId,

            fileUrl: that.ruleForm.fileUrl
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              that.ruleForm.fileUrl = response.data.data;
              that.$notify({
                title: "",
                message: "上传成功",
                type: "success"
              });
              that.outerVisible2 = false;
              //  that.percentageShow =  true;
              setTimeout(() => {
                that.percentage = 100;
                that.percentagestatus = "success";
              }, 100);
            } else {
              http.handleEorrorCode(response, that);
              that.outerVisible2 = false;
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
      } else if (this.DialogTitle === "审核") {
        let that = this;
        that.outerVisible3 = false;
        // that.disabled = false;
        const options = {
          url: "/distribution/B2cTobDepositController/checkDeposit",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            depositStatus: 2,
            // that.ruleForm.depositStatus,
            depositId: that.ruleForm.depositId
          })
        };
        axios(options)
          .then(function(response) {
            that.outerVisible3 = false;
            // that.disabled = false;
            if (response.data.code == 200) {
              that.initData();
              that.$notify({
                title: "成功",
                message: "审核成功",
                type: "success"
              });
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(function(error) {
            that.outerVisible3 = false;
            // that.disabled = false;
            http.handleHttpError(error, that);
          });

        //
      }
    },

    // 导出数据
    // 导出数据
    exp() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOrderController/orderExport",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {}
      };
      axios(options)
        .then(function(response) {
          if (response.data.code !== undefined) {
            http.handleEorrorCode(response, that);
          } else {
            that.ExportClickSecond();
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    ExportClickSecond() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOrderController/orderExport",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {},
        responseType: "blob"
      };
      axios(options)
        .then(function(response) {
          var filename = "保证金订单列表" + new Date().getTime();
          let url = window.URL.createObjectURL(response.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },

    // 删除的 处理函数
    del(item) {
      //console.log(row);
      this.outerVisible1 = true;
      this.EditDialog = 2;
      this.ruleForm = MethodsBus.cloneRow(item);
      // this.CurrentSelection = item;
    },
    // 编辑函数
    edit(row) {
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.initDatarecomNameList();
      this.ruleForm = MethodsBus.cloneRow(row);
      if (this.fileList) {
        this.fileList.splice(0, this.fileList.length);
      }
      var obj = {};
      obj.name = this.ruleForm.contractTitle;
      obj.url = this.ruleForm.fileUrl;

      this.fileList.push(obj);
      console.log(row);
    },

    // 对话框删除的  处理函数  ------ 【确定 按钮】
    MakeSure() {
      let that = this;
      that.disabled = true;
      const options = {
        url: "/distribution/B2cTobDepositController/deleteDeposit",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          depositId: that.ruleForm.depositId
        })
      };
      axios(options)
        .then(response => {
          that.outerVisible1 = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initData();
            that.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    jujue(formName) {
      this.innerVisible = true;
      // this.outerVisible = false;
      this.$prompt("理由：", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /./g,
        inputPlaceholder: "请输入拒绝审核理由",
        inputErrorMessage: "请输入拒绝审核理由"
      })
        .then(({ value }) => {
          let that = this;
          that.outerVisible3 = false;
          that.disabled = false;
          const options = {
            url: "/distribution/B2cTobDepositController/checkDeposit",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: Qs.stringify({
              depositStatus: 0,
              depositId: that.ruleForm.depositId,
              depositRemark: value
            })
          };
          axios(options)
            .then(function(response) {
              that.outerVisible3 = false;
              that.disabled = false;
              if (response.data.code == 200) {
                that.initData();
                that.$notify({
                  title: "成功",
                  message: "拒绝审核",
                  type: "success"
                });
              } else {
                http.handleEorrorCode(response, that);
              }
            })
            .catch(function(error) {
              that.outerVisible3 = false;
              that.disabled = false;
              http.handleHttpError(error, that);
            });

          this.outerVisible3 = false;
        })
        .catch(() => {
          this.outerVisible3 = true;
        });
    },
    //   startTime  开始时间
    getstarttime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var date = now.getDate(); //得到日期
      //   var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒

      if (now.getMonth() + 1) {
        if (month < 10) month = "0" + (now.getMonth() + 1);
        date = "0" + "1";
        hour = "0" + "0";
        minu = "0" + "0";
        sec = "0" + "0";
      }
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    // endtime;结束时间
    getEndtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    //  时间的处理函数
    ChangePicker() {
      if (this.Formdata.TimeValue) {
        this.startTime = this.FormatAllDate(this.Formdata.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.Formdata.TimeValue[1]);
      } else if (!this.Formdata.TimeValue) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;
      return currentdate;
    },
    FormatAllDateadd() {
      this.ruleForm.depositTime = this.FormatAllDate(this.ruleForm.depositTime);
    },
    // 分页处理函数 分页-- 获取 每页  value条
    handleSizeChange(value) {
      this.pageSize = value;

      this.pageNo = 1;
      this.initData();
    },
    //  获取 当前  value
    handleCurrentChange(value) {
      this.pageNo = value;
      this.initData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.left {
  margin-left: 15px;
}
.upload {
  margin-top: 20px;
  margin-left: 13%;
  display: flex;
  justify-content: flex-start;
}
.shangchuang {
  margin-left: 20px;
}
.upload_left {
  /* margin-top: 50px; */
  margin-left: 50px;
  padding-right: 30px;
  letter-spacing: 1px;
  font-weight: bold;
}
/*  */
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.top-hd {
  margin-top: 20px;
  margin-left: 1%;
}
.right_btn {
  float: right;
  margin-top: 60px;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.upload_right {
  margin-left: 20px;
}
.upload_right1 {
  margin-left: 15px;
}
.upload_right2 {
  display: flex;
}

.box-card {
  width: 100%;
}
.top-input {
  margin-left: 25px;
}
.inputclass {
  margin-left: 12%;
}
.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.bottom_table {
  display: flex;
  justify-content: flex-start;
}
.border-main {
  width: 400px;
  height: 80px;
  margin-left: 8%;
}
.border-main > h5 {
  color: #161a1e;
  font-size: 15px;
  margin-top: 15%;
}
.border-main > h5 b {
  color: #e4393c;
}
.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.top-thone {
  margin-left: 20px;
  margin-top: 20px;
}
.btn1 {
  background-color: #fff;
  margin-left: 10%;
  font-size: 12px;
  color: #242a30;
}
.inputclass1 {
  margin-left: 15%;
  width: 130%;
}
.inputclass2 {
  width: 120%;
}
.bot-btn {
  float: left;
  margin-left: 3%;
  margin-top: 1%;
}
.bot-btn-left {
  margin-left: 70px;
}
.a_class {
  padding: 8px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/deposit.vue